import { useState } from 'react';
import { Chip } from '@mui/material';
import { WeeklyAvailabilityEditDialog } from './weekly-availability-edit-dialog';
import { availability } from './weekly-availability-edit-dialog/availability';
import { useRecommendationProfile } from '@/context/recommendation-profile';
import { ProfileItem } from '@/packages/my-profile/components/profile-item';

export const WeeklyAvailability = () => {
  const { profile, updateProfile } = useRecommendationProfile();
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const maxHoursAvailablePerWeek =
    profile?.max_hours_available_per_week || null;

  const handleSaveWeeklyAvailability = (value: number | null) => {
    updateProfile({
      profile: {
        ...profile,
        max_hours_available_per_week: value,
        ...(value === null && { min_hours_available_per_week: 10 }),
      },
    });
  };

  const weeklyAvailabilityLabel = availability.find(
    (currentAvailability) =>
      currentAvailability.value === maxHoursAvailablePerWeek
  )?.label;

  const hasWeeklyAvailability =
    profile?.max_hours_available_per_week ||
    profile?.min_hours_available_per_week;

  return (
    <>
      <ProfileItem
        title="Disponibilidade semanal"
        onClick={() => setIsDialogOpen(true)}
      >
        {hasWeeklyAvailability && (
          <Chip
            key={profile?.max_hours_available_per_week}
            label={weeklyAvailabilityLabel}
          />
        )}
      </ProfileItem>
      {isDialogOpen && profile && (
        <WeeklyAvailabilityEditDialog
          currentValue={maxHoursAvailablePerWeek}
          onClose={() => setIsDialogOpen(false)}
          onSave={handleSaveWeeklyAvailability}
          hasValue={!!hasWeeklyAvailability}
        />
      )}
    </>
  );
};
